import React from 'react';
import { Link } from 'react-router-dom';
import './ImageShowcase.css';

const ImageShowcase = ({
  image,
  label,
  title,
  description,
  link,
  linkText = 'Learn More',
  reverse = false
}) => {
  return (
    <section className={`image-showcase ${reverse ? 'image-showcase-reverse' : ''}`}>
      <div className="image-showcase-image">
        <img src={image} alt={title} loading="lazy" />
      </div>
      <div className="image-showcase-content">
        <div className="image-showcase-inner">
          {label && <span className="section-label">{label}</span>}
          <h2 className="section-title">{title}</h2>
          {description && <p className="section-subtitle">{description}</p>}
          {link && (
            link.startsWith('#') ? (
              <a href={link} className="image-showcase-link">
                {linkText} <span>&gt;</span>
              </a>
            ) : (
              <Link to={link} className="image-showcase-link">
                {linkText} <span>&gt;</span>
              </Link>
            )
          )}
        </div>
      </div>
    </section>
  );
};

export default ImageShowcase;
